import { PlanAttributeType } from '../models/client-product-attribute.model';

export interface PlanAttributeDisplayValue {
  attributeType: PlanAttributeType;
  value?: string | null;
  unit?: string | null;
  boolValue?: boolean;
}

export function formatPlanAttributeValue(attr: PlanAttributeDisplayValue): string {
  if (attr.attributeType === 'Boolean') {
    const on = attr.boolValue ?? attr.value === '1';
    return on ? 'Yes' : 'No';
  }

  const value = (attr.value ?? '').trim();
  if (!value) {
    return '—';
  }

  return attr.attributeType === 'Numeric' && attr.unit ? `${value} ${attr.unit}` : value;
}

/** Full-value tooltip for long Text attributes in read-only display; null when not needed. */
export function planAttributeTextTooltip(attr: PlanAttributeDisplayValue): string | null {
  if (attr.attributeType !== 'Text') {
    return null;
  }

  const formatted = formatPlanAttributeValue(attr);
  if (formatted === '—' || formatted.length <= 60) {
    return null;
  }

  return formatted;
}
